import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class FlightReportsMeasurementCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      range: 2,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            bases_select: responseJson.data.bases_select,
            flight_types_select: responseJson.data.flight_types_select,
            clients_select: responseJson.data.clients_select,
            clients_full_select: responseJson.data.clients_full_select,
            receits_select: responseJson.data.receits_select,
            staffs_select: responseJson.data.staffs_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      aircraft_id: this.state.aircraft_id,
      contract_id: this.state.contract_id,
      contract_base_id: this.state.contract_base_id,
      client_id: this.state.client_id,
      range: this.state.range,
      status: this.state.status,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/conferencia/medicao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.main, headers: responseJson.data.headers, searched: 1});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    var columns = null

    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.Contrato}:</label>
            <Select
              className=""
              name="contract_id"
              value={this.state.contract_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_id')}
              options={this.state.clients_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.Cliente}:</label>
            <Select
              className=""
              name="client_id"
              value={this.state.client_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'client_id')}
              options={this.state.clients_full_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.TipoDeMedicao}:</label>
            <Select
              className=""
              name="range"
              value={this.state.range}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'range')}
              options={[
                {value: 1, label: this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.opcoesMedicao.Sintetica},
                {value: 2, label: this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.opcoesMedicao.Analitica},
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.SomenteAprovados}:</label>
            <Select
              className=""
              name="status"
              value={this.state.status}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'status')}
              options={[
                {value: 1, label: this.locale.general.sim},
                {value: 0, label: this.locale.general.nao},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.BaseContratual}:</label>
            <Select
              className=""
              name="contract_base_id"
              value={this.state.contract_base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_base_id')}
              options={this.state.bases_select}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      {self.state.searched === 1 &&
          <div>
            <hr/>
            <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
              <TableHeaderColumn dataField={'contract'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract_aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.PrefixoContrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'available_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Status}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.NumeroDoVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'client'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Cliente}</TableHeaderColumn>
              <TableHeaderColumn dataField={'ptbr_code'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.CodigoPTBR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'departure_location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.LocalidadeInicio}</TableHeaderColumn>
              <TableHeaderColumn dataField={'arrival_location'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.LocalidadeFim}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Prefixo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'start_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Inicio}</TableHeaderColumn>
              <TableHeaderColumn dataField={'finish_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Fim}</TableHeaderColumn>
            </BootstrapTable>
          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportsMeasurementCheck;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/FlightReportsMeasurementCheck.js